module.exports = __webpack_public_path__ + "img/dpsy-icon-qn.0becc091.png";